import { WidgetControlType } from '@examdojo/core/widget';
import type { QuadraticPreset } from './quadratic-preset.model';

export const EXPLORATION_PRESET: QuadraticPreset = {
  id: 'exploration',
  title: 'Exploration Mode',
  description: 'Full interactive exploration with slider controls',
  config: {
    id: 'quadratic-exploration',
    type: 'quadratic-function',
    params: {
      a: 1,
      b: -4,
      c: -3,
    },
    display: {
      grid: false,
      axes: true,
      vertex: { enabled: true, label: { show: true, format: 'name' } },
      roots: { enabled: true, label: { show: true, format: 'name' } },
      axisOfSymmetry: { enabled: true, label: { show: false } },
      yIntercept: { enabled: true, label: { show: true, format: 'name' } },
      parabola: { strokeWidth: 3 },
    },
    behavior: {
      features: {
        sliders: false,
        interaction: true,
      },
      controls: [
        {
          id: 'slider-a',
          type: WidgetControlType.Slider,
          label: 'Coefficient a',
          param: 'a',
          position: 'canvas-overlay',
          min: -5,
          max: 5,
          step: 0.1,
          defaultValue: 1,
          editable: true,
          color: 'purple',
          trigger: { action: 'UPDATE_COEFFICIENTS', payload: { param: 'a' } },
        },
        {
          id: 'slider-b',
          type: WidgetControlType.Slider,
          label: 'Coefficient b',
          param: 'b',
          position: 'canvas-overlay',
          min: -10,
          max: 10,
          step: 0.1,
          defaultValue: -4,
          editable: true,
          color: 'pink',
          trigger: { action: 'UPDATE_COEFFICIENTS', payload: { param: 'b' } },
        },
        {
          id: 'slider-c',
          type: WidgetControlType.Slider,
          label: 'Coefficient c',
          param: 'c',
          position: 'canvas-overlay',
          min: -10,
          max: 10,
          step: 0.1,
          defaultValue: -3,
          editable: true,
          color: 'amber',
          trigger: { action: 'UPDATE_COEFFICIENTS', payload: { param: 'c' } },
        },
      ],
    },
  },
};
